import { jsx as o } from "./index12.mjs";
import { ThemeProvider as m } from "@emotion/react";
const d = ({ theme: r, children: e }) => /* @__PURE__ */ o(m, { theme: r, children: e });
export {
  d as ThemeProvider
};
